export default __webpack_public_path__ + "static/media/image9.0836cb71.png";